export default "__VITE_ASSET__PeoeN$$x__"